export default {
  ignoreKeyDown(e) {
    const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    const isDelBtn =
      (isMacLike && e.code === 'Backspace') || e.code === 'Delete';
    const { tagName, isContentEditable } = document.activeElement;
    if (
      !isDelBtn ||
      tagName === 'INPUT' ||
      tagName === 'TEXTAREA' ||
      isContentEditable
    )
      return true;
    return false;
  },

  ignoreHotKeys() {
    const { tagName, isContentEditable } = document.activeElement;
    return tagName === 'INPUT' || tagName === 'TEXTAREA' || isContentEditable;
  },

  isDeleteBtn(e) {
    const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    return (isMacLike && e.code === 'Backspace') || e.code === 'Delete';
  },
};
